/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};

(function () {
  'use strict';
  /**
   * Хэлпер для отправки в VK.
   * @type {Object}
   */
  app.helpers.vkTargetingHelper = {
    /**
     * Код валюты для продуктовых vk событий
     */
    CURRENCY_CODE: 'RUR',
    /**
     * Глобальный объект vk retargeting
     * @returns {Object} vk retargeting
     */
    get globalVKTargeting () {
      return _.get(window, 'VK.Retargeting', {});
    },
    /**
     * Идентификатор vk прайс листа 
     * @returns {number} прайс лист
     */
    get priceListId () {
      return window.app.vkPriceListId;
    },

    /**
     * Отправка продуктового события
     * @param {string} eventType Тип события
     * @param {Object} params    Параметры
     */
    pushProductEvent: function (eventType, params) {
      if (typeof eventType === 'string' && typeof params === 'object') {
        if (typeof params.products !== 'undefined') {
          params.currency_code = this.CURRENCY_CODE;
        }
        if (_.isFunction(this.globalVKTargeting.ProductEvent)) {
          this.globalVKTargeting.ProductEvent(this.priceListId, eventType, params);
        }
      }
    },
  };
})();

}.call(window));